import Resource from "api/resource";

class ClientResource extends Resource {
  constructor() {
    super("clients");
  }
}

export { ClientResource as default };
